module.exports = __webpack_public_path__ + "img/placeholder_UHK.9901df0a.jpg";